export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_08.70eee5cf.jpg";